import { combineReducers } from "redux";
import tenantProfileReducer from "./tenantProfileReducer";

const tenantProfReducer = combineReducers({
  tenantProfile: tenantProfileReducer,
});

export default tenantProfReducer;
